import {
	isStoreHuman,
	type StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

export const updateHumanMessageId = ({
	chat,
	oldId,
	newId,
	parentMessageId,
	onMessageIdChanged,
}: {
	chat: StoreChatItem[];
	oldId: string;
	newId: string;
	parentMessageId?: string | null;
	onMessageIdChanged?: (oldId: string, newId: string) => void;
}): StoreChatItem[] =>
	chat.map((message) => {
		if (isStoreHuman(message) && message.content.id === oldId) {
			onMessageIdChanged?.(oldId, newId);

			return {
				...message,
				promptContextMessageId: message.promptContextMessageId ?? oldId,
				content: {
					...message.content,
					id: newId,
					...(parentMessageId && { parent_message_id: parentMessageId }),
				},
			};
		}
		return message;
	});
